import env from 'enviro';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { getUtk } from '../earlyRequester/earlyRequesterUtils';
import { useActiveFeatureFlags } from '../v2/hooks/gating/useIsUngated';
import { useUserInfo } from '../v2/hooks/user/useUserInfo';
import { getBrowserLocale } from '../utils/getBrowserLocale';

/**
 * Hook to determine if the current user is on the HubSpot Credits pilot.
 *
 * TODO [HSoC]: Determine if user is in pilot for public pricing page
 */
export function useIsHubSpotOnCreditsPilot() {
  var _userInfo$user;
  const isQA = env.isQa() || getIsQAProxy();
  const {
    userInfo,
    loading: userInfoLoading,
    error: userInfoError
  } = useUserInfo();
  const scopes = new Set((userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.scopes) || []);
  const hasScope = scopes.has('hubspot-on-credits');
  const {
    browserLocale,
    preferredCountryCode
  } = getBrowserLocale();
  const utk = getUtk() || '';
  const {
    featureFlags,
    loading: featureFlagLoading,
    error: featureFlagError
  } = useActiveFeatureFlags({
    utk,
    browserLocale,
    preferredCountryCode,
    skip: !!userInfo
  });
  const hasFeatureFlag = featureFlags.includes('hubspotoncredits');
  return {
    isInPilot: (hasScope || hasFeatureFlag) &&
    // TODO [HSoC]: remove once pilot is ready
    isQA,
    loading: userInfoLoading || featureFlagLoading,
    error: userInfoError || featureFlagError
  };
}